import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import useWindowSize from '@hooks/useWindowSize';

import ArtworkList from '@features/assets/components/artwork/ArtworkList';
import AssetsTopFilter from '@features/assets/components/AssetsTopFilter';
import BlockLibrary from '@features/assets/components/blockLibrary/BlockLibrary';
import SketchList from '@features/assets/components/sketch/SketchList';

import { getUserInfo } from '@utils/Util';

import { ASSETS_TABS } from '@/features/assets/constants';

const AssetsWrapper = () => {
	const [isOpenFilter, setIsOpenFilter] = useState(true);
	const [totalElements, setTotalElements] = useState(0);
	const [activeTab, setActiveTab] = useState('');
	const [showAddModal, setShowAddModal] = useState(false);
	const [selectedViewType, setSelectedViewType] = useState(
		getUserInfo().systemPreference?.BLOCK_LIBRARY_LIST_TYPE
	);
	const navigate = useNavigate();
	useWindowSize(() => setIsOpenFilter(false));
	const location = useLocation();
	const [artworkSummaryCount, setArtworkSummaryCount] = useState(null);

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const tab = params.get('activeTab');

		if (tab) {
			setActiveTab(tab);
		}
	}, [location.search]);

	const handleTabChange = (tabName) => {
		setActiveTab(tabName);
		navigate(`/assets?activeTab=${tabName}`);
		window.scrollTo(0, 0);
	};

	const onSetViewSetting = (selected) => {
		setSelectedViewType(selected);
	};

	const renderTabContents = () => {
		switch (activeTab) {
			case 'BLOCK_LIBRARY':
				return (
					<BlockLibrary
						toggleFilter={() => setIsOpenFilter((prev) => !prev)}
						isShowFilter={isOpenFilter}
						selectedViewType={selectedViewType}
						activeTab={activeTab}
						setTotalElements={setTotalElements}
					/>
				);
			case 'SKETCH':
				return (
					<SketchList
						toggleFilter={() => setIsOpenFilter((prev) => !prev)}
						isShowFilter={isOpenFilter}
						setTotalElements={setTotalElements}
						showAddModal={showAddModal}
						setShowAddModal={setShowAddModal}
					/>
				);
			case 'ARTWORK':
				return (
					<ArtworkList
						toggleFilter={() => setIsOpenFilter((prev) => !prev)}
						isShowFilter={isOpenFilter}
						setTotalElements={setTotalElements}
						showAddModal={showAddModal}
						setShowAddModal={setShowAddModal}
						setArtworkSummaryCount={setArtworkSummaryCount}
					/>
				);

			default:
				return <></>;
		}
	};

	return (
		<>
			<div className="top-header bg-white assets-top-filter">
				<div className="page-title-area">
					<h1 className="semibold-16">ASSETS</h1>
				</div>
				<div className="navigation-tab shadow-nav-4dp">
					<ul>
						<li
							onClick={() => handleTabChange(ASSETS_TABS.BLOCK_LIBRARY)}
							className={activeTab === ASSETS_TABS.BLOCK_LIBRARY ? 'active' : ''}
						>
							Block Library
						</li>
						<li
							onClick={() => handleTabChange(ASSETS_TABS.SKETCH)}
							className={activeTab === ASSETS_TABS.SKETCH ? 'active' : ''}
						>
							Sketch
						</li>
						<li
							onClick={() => handleTabChange(ASSETS_TABS.ARTWORK)}
							className={activeTab === ASSETS_TABS.ARTWORK ? 'active' : ''}
						>
							Artwork
						</li>
					</ul>
				</div>
				<AssetsTopFilter
					onSetViewSetting={onSetViewSetting}
					selectedViewType={selectedViewType}
					toggleFilter={() => setIsOpenFilter((prev) => !prev)}
					activeTab={activeTab}
					totalElements={totalElements}
					setShowAddModal={setShowAddModal}
					artworkSummaryCount={artworkSummaryCount}
				/>
			</div>

			{renderTabContents()}
		</>
	);
};

export default AssetsWrapper;
